import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { State } from "../../../store/state";
import { ShareType } from "../../../types/Enums";
import { CauseArea } from "../../../types/CauseArea";
export const useAmountCalculation = (selectionType, selectedCauseAreaId, causeAreas) => {
  const $ = _c(53);
  const {
    causeAreaAmounts: t0,
    orgAmounts: t1,
    causeAreaDistributionType: t2,
    operationsPercentageByCauseArea: t3,
    globalOperationsEnabled: t4,
    operationsConfig,
    smartDistributionTotal: t5
  } = useSelector(_temp);
  let t6;
  if ($[0] !== t0) {
    t6 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const causeAreaAmounts = t6;
  let t7;
  if ($[2] !== t1) {
    t7 = t1 === undefined ? {} : t1;
    $[2] = t1;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const orgAmounts = t7;
  let t8;
  if ($[4] !== t2) {
    t8 = t2 === undefined ? {} : t2;
    $[4] = t2;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const causeAreaDistributionType = t8;
  const operationsPercentageByCauseArea = t3 === undefined ? {} : t3;
  const globalOperationsEnabled = t4 === undefined ? false : t4;
  const smartDistributionTotal = t5 === undefined ? 0 : t5;
  const OPERATIONS_CAUSE_AREA_ID = operationsConfig?.operationsCauseAreaId;
  let t9;
  if ($[6] !== OPERATIONS_CAUSE_AREA_ID || $[7] !== causeAreaAmounts || $[8] !== causeAreaDistributionType || $[9] !== causeAreas || $[10] !== orgAmounts || $[11] !== selectedCauseAreaId || $[12] !== selectionType) {
    t9 = Object.keys(causeAreaAmounts).reduce((acc, key) => {
      const causeAreaId = parseInt(key);
      if (causeAreaId === OPERATIONS_CAUSE_AREA_ID) {
        return acc;
      }
      if (selectionType === "single" && selectedCauseAreaId !== causeAreaId) {
        return acc;
      }
      let amountForThisCauseArea = 0;
      if (causeAreaDistributionType[causeAreaId] === ShareType.CUSTOM) {
        const currentCauseArea = causeAreas.find(ca => ca.id === causeAreaId);
        if (currentCauseArea) {
          amountForThisCauseArea = currentCauseArea.organizations.reduce((orgSum, org) => orgSum + (Number(orgAmounts[org.id]) || 0), 0);
        }
      } else {
        amountForThisCauseArea = Number(causeAreaAmounts[causeAreaId]) || 0;
      }
      return acc + amountForThisCauseArea;
    }, 0);
    $[6] = OPERATIONS_CAUSE_AREA_ID;
    $[7] = causeAreaAmounts;
    $[8] = causeAreaDistributionType;
    $[9] = causeAreas;
    $[10] = orgAmounts;
    $[11] = selectedCauseAreaId;
    $[12] = selectionType;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const sumOfOtherCauseAreas = t9;
  let currentTotal = 0;
  if (selectedCauseAreaId === -1) {
    let t10;
    if ($[14] !== OPERATIONS_CAUSE_AREA_ID || $[15] !== causeAreaAmounts || $[16] !== causeAreaDistributionType || $[17] !== causeAreas || $[18] !== orgAmounts) {
      let t11;
      if ($[20] !== OPERATIONS_CAUSE_AREA_ID || $[21] !== causeAreaAmounts || $[22] !== causeAreaDistributionType || $[23] !== orgAmounts) {
        t11 = (acc_0, area) => {
          if (causeAreaDistributionType[area.id] === ShareType.CUSTOM && area.id !== OPERATIONS_CAUSE_AREA_ID) {
            return acc_0 + area.organizations.reduce((orgAcc, org_0) => orgAcc + (orgAmounts[org_0.id] || 0), 0);
          }
          return acc_0 + (causeAreaAmounts[area.id] || 0);
        };
        $[20] = OPERATIONS_CAUSE_AREA_ID;
        $[21] = causeAreaAmounts;
        $[22] = causeAreaDistributionType;
        $[23] = orgAmounts;
        $[24] = t11;
      } else {
        t11 = $[24];
      }
      t10 = causeAreas.reduce(t11, 0);
      $[14] = OPERATIONS_CAUSE_AREA_ID;
      $[15] = causeAreaAmounts;
      $[16] = causeAreaDistributionType;
      $[17] = causeAreas;
      $[18] = orgAmounts;
      $[19] = t10;
    } else {
      t10 = $[19];
    }
    currentTotal = t10;
  } else {
    if (selectionType === "multiple") {
      let t10;
      if ($[25] !== OPERATIONS_CAUSE_AREA_ID || $[26] !== causeAreaAmounts || $[27] !== causeAreaDistributionType || $[28] !== causeAreas || $[29] !== orgAmounts) {
        let t11;
        if ($[31] !== OPERATIONS_CAUSE_AREA_ID) {
          t11 = ca_0 => ca_0.id !== 5 && ca_0.id !== OPERATIONS_CAUSE_AREA_ID;
          $[31] = OPERATIONS_CAUSE_AREA_ID;
          $[32] = t11;
        } else {
          t11 = $[32];
        }
        let t12;
        if ($[33] !== causeAreaAmounts || $[34] !== causeAreaDistributionType || $[35] !== orgAmounts) {
          t12 = (acc_1, area_0) => {
            if (causeAreaDistributionType[area_0.id] === ShareType.CUSTOM) {
              return acc_1 + area_0.organizations.reduce((orgAcc_0, org_1) => orgAcc_0 + (orgAmounts[org_1.id] || 0), 0);
            }
            return acc_1 + (causeAreaAmounts[area_0.id] || 0);
          };
          $[33] = causeAreaAmounts;
          $[34] = causeAreaDistributionType;
          $[35] = orgAmounts;
          $[36] = t12;
        } else {
          t12 = $[36];
        }
        t10 = causeAreas.filter(t11).reduce(t12, 0);
        $[25] = OPERATIONS_CAUSE_AREA_ID;
        $[26] = causeAreaAmounts;
        $[27] = causeAreaDistributionType;
        $[28] = causeAreas;
        $[29] = orgAmounts;
        $[30] = t10;
      } else {
        t10 = $[30];
      }
      currentTotal = t10;
      currentTotal = currentTotal + smartDistributionTotal;
    } else {
      if (selectionType === "single" && selectedCauseAreaId != null) {
        if ($[37] !== causeAreaAmounts || $[38] !== causeAreaDistributionType || $[39] !== causeAreas || $[40] !== orgAmounts || $[41] !== selectedCauseAreaId) {
          let t10;
          if ($[43] !== selectedCauseAreaId) {
            t10 = area_1 => area_1.id === selectedCauseAreaId;
            $[43] = selectedCauseAreaId;
            $[44] = t10;
          } else {
            t10 = $[44];
          }
          const selectedArea = causeAreas.find(t10);
          if (selectedArea) {
            if (causeAreaDistributionType[selectedCauseAreaId] === ShareType.STANDARD) {
              currentTotal = 0 + (causeAreaAmounts[selectedCauseAreaId] || 0);
            } else {
              let t11;
              if ($[45] !== orgAmounts) {
                t11 = (orgAcc_1, org_2) => orgAcc_1 + (orgAmounts[org_2.id] || 0);
                $[45] = orgAmounts;
                $[46] = t11;
              } else {
                t11 = $[46];
              }
              currentTotal = 0 + selectedArea.organizations.reduce(t11, 0);
            }
          }
          $[37] = causeAreaAmounts;
          $[38] = causeAreaDistributionType;
          $[39] = causeAreas;
          $[40] = orgAmounts;
          $[41] = selectedCauseAreaId;
          $[42] = currentTotal;
        } else {
          currentTotal = $[42];
        }
      }
    }
  }
  const totalAmount = currentTotal;
  let t10;
  if ($[47] !== causeAreaAmounts || $[48] !== causeAreaDistributionType || $[49] !== orgAmounts || $[50] !== sumOfOtherCauseAreas || $[51] !== totalAmount) {
    t10 = {
      sumOfOtherCauseAreas,
      totalAmount,
      causeAreaAmounts,
      orgAmounts,
      causeAreaDistributionType
    };
    $[47] = causeAreaAmounts;
    $[48] = causeAreaDistributionType;
    $[49] = orgAmounts;
    $[50] = sumOfOtherCauseAreas;
    $[51] = totalAmount;
    $[52] = t10;
  } else {
    t10 = $[52];
  }
  return t10;
};
function _temp(state) {
  return state.donation;
}